/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as appRouteRouteImport } from './routes/(app)/route'
import { Route as dashboardRouteRouteImport } from './routes/(dashboard)/route'
import { Route as appBargeControlRouteImport } from './routes/(app)/bargeControl'
import { Route as appDevRouteImport } from './routes/(app)/dev'
import { Route as appGamepadLayoutScreenRouteImport } from './routes/(app)/gamepadLayoutScreen'
import { Route as appHybridPowerRouteImport } from './routes/(app)/hybrid-power'
import { Route as appOrbitOneRouteImport } from './routes/(app)/orbitOne'
import { Route as appPenViewerRouteImport } from './routes/(app)/penViewer'
import { Route as appUpCycleRouteImport } from './routes/(app)/upCycle'
import { Route as appUtilsRouteRouteImport } from './routes/(app)/utils/route'
import { Route as dashboardIndexRouteImport } from './routes/(dashboard)/index'
import { Route as dashboardLayoutsRouteRouteImport } from './routes/(dashboard)/layouts/route'
import { Route as appUtilsAutomationRouteImport } from './routes/(app)/utils/automation'
import { Route as appUtilsCameraCheckRouteImport } from './routes/(app)/utils/cameraCheck'
import { Route as appUtilsDeviceConfigRouteImport } from './routes/(app)/utils/deviceConfig'
import { Route as appUtilsEventStreamRouteImport } from './routes/(app)/utils/eventStream'
import { Route as appUtilsInventoryRouteImport } from './routes/(app)/utils/inventory'
import { Route as appUtilsNetworkHealthRouteImport } from './routes/(app)/utils/networkHealth'
import { Route as appUtilsPlaygroundRouteImport } from './routes/(app)/utils/playground'
import { Route as appUtilsSettingsRouteImport } from './routes/(app)/utils/settings'
import { Route as appUtilsSiteSetupRouteImport } from './routes/(app)/utils/siteSetup'
import { Route as dashboardLayoutsIndexRouteImport } from './routes/(dashboard)/layouts/index'
import { Route as dashboardLayoutsIdRouteImport } from './routes/(dashboard)/layouts/$id'
import { Route as dashboardLayoutsNewRouteImport } from './routes/(dashboard)/layouts/new'

const appRouteRoute = appRouteRouteImport.update({
  id: '/(app)',
  getParentRoute: () => rootRouteImport,
} as any)
const dashboardRouteRoute = dashboardRouteRouteImport.update({
  id: '/(dashboard)',
  getParentRoute: () => rootRouteImport,
} as any)
const appBargeControlRoute = appBargeControlRouteImport.update({
  id: '/bargeControl',
  path: '/bargeControl',
  getParentRoute: () => appRouteRoute,
} as any)
const appDevRoute = appDevRouteImport.update({
  id: '/dev',
  path: '/dev',
  getParentRoute: () => appRouteRoute,
} as any)
const appGamepadLayoutScreenRoute = appGamepadLayoutScreenRouteImport.update({
  id: '/gamepadLayoutScreen',
  path: '/gamepadLayoutScreen',
  getParentRoute: () => appRouteRoute,
} as any)
const appHybridPowerRoute = appHybridPowerRouteImport.update({
  id: '/hybrid-power',
  path: '/hybrid-power',
  getParentRoute: () => appRouteRoute,
} as any)
const appOrbitOneRoute = appOrbitOneRouteImport.update({
  id: '/orbitOne',
  path: '/orbitOne',
  getParentRoute: () => appRouteRoute,
} as any)
const appPenViewerRoute = appPenViewerRouteImport.update({
  id: '/penViewer',
  path: '/penViewer',
  getParentRoute: () => appRouteRoute,
} as any)
const appUpCycleRoute = appUpCycleRouteImport.update({
  id: '/upCycle',
  path: '/upCycle',
  getParentRoute: () => appRouteRoute,
} as any)
const appUtilsRouteRoute = appUtilsRouteRouteImport.update({
  id: '/utils',
  path: '/utils',
  getParentRoute: () => appRouteRoute,
} as any)
const dashboardIndexRoute = dashboardIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => dashboardRouteRoute,
} as any)
const dashboardLayoutsRouteRoute = dashboardLayoutsRouteRouteImport.update({
  id: '/layouts',
  path: '/layouts',
  getParentRoute: () => dashboardRouteRoute,
} as any)
const appUtilsAutomationRoute = appUtilsAutomationRouteImport.update({
  id: '/automation',
  path: '/automation',
  getParentRoute: () => appUtilsRouteRoute,
} as any)
const appUtilsCameraCheckRoute = appUtilsCameraCheckRouteImport.update({
  id: '/cameraCheck',
  path: '/cameraCheck',
  getParentRoute: () => appUtilsRouteRoute,
} as any)
const appUtilsDeviceConfigRoute = appUtilsDeviceConfigRouteImport.update({
  id: '/deviceConfig',
  path: '/deviceConfig',
  getParentRoute: () => appUtilsRouteRoute,
} as any)
const appUtilsEventStreamRoute = appUtilsEventStreamRouteImport.update({
  id: '/eventStream',
  path: '/eventStream',
  getParentRoute: () => appUtilsRouteRoute,
} as any)
const appUtilsInventoryRoute = appUtilsInventoryRouteImport.update({
  id: '/inventory',
  path: '/inventory',
  getParentRoute: () => appUtilsRouteRoute,
} as any)
const appUtilsNetworkHealthRoute = appUtilsNetworkHealthRouteImport.update({
  id: '/networkHealth',
  path: '/networkHealth',
  getParentRoute: () => appUtilsRouteRoute,
} as any)
const appUtilsPlaygroundRoute = appUtilsPlaygroundRouteImport.update({
  id: '/playground',
  path: '/playground',
  getParentRoute: () => appUtilsRouteRoute,
} as any)
const appUtilsSettingsRoute = appUtilsSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => appUtilsRouteRoute,
} as any)
const appUtilsSiteSetupRoute = appUtilsSiteSetupRouteImport.update({
  id: '/siteSetup',
  path: '/siteSetup',
  getParentRoute: () => appUtilsRouteRoute,
} as any)
const dashboardLayoutsIndexRoute = dashboardLayoutsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => dashboardLayoutsRouteRoute,
} as any)
const dashboardLayoutsIdRoute = dashboardLayoutsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => dashboardLayoutsRouteRoute,
} as any)
const dashboardLayoutsNewRoute = dashboardLayoutsNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => dashboardLayoutsRouteRoute,
} as any)

export interface FileRoutesByFullPath {
  '/utils': typeof appUtilsRouteRouteWithChildren
  '/layouts': typeof dashboardLayoutsRouteRouteWithChildren
  '/bargeControl': typeof appBargeControlRoute
  '/dev': typeof appDevRoute
  '/gamepadLayoutScreen': typeof appGamepadLayoutScreenRoute
  '/hybrid-power': typeof appHybridPowerRoute
  '/orbitOne': typeof appOrbitOneRoute
  '/penViewer': typeof appPenViewerRoute
  '/upCycle': typeof appUpCycleRoute
  '/': typeof dashboardIndexRoute
  '/utils/automation': typeof appUtilsAutomationRoute
  '/utils/cameraCheck': typeof appUtilsCameraCheckRoute
  '/utils/deviceConfig': typeof appUtilsDeviceConfigRoute
  '/utils/eventStream': typeof appUtilsEventStreamRoute
  '/utils/inventory': typeof appUtilsInventoryRoute
  '/utils/networkHealth': typeof appUtilsNetworkHealthRoute
  '/utils/playground': typeof appUtilsPlaygroundRoute
  '/utils/settings': typeof appUtilsSettingsRoute
  '/utils/siteSetup': typeof appUtilsSiteSetupRoute
  '/layouts/$id': typeof dashboardLayoutsIdRoute
  '/layouts/new': typeof dashboardLayoutsNewRoute
  '/layouts/': typeof dashboardLayoutsIndexRoute
}
export interface FileRoutesByTo {
  '/utils': typeof appUtilsRouteRouteWithChildren
  '/bargeControl': typeof appBargeControlRoute
  '/dev': typeof appDevRoute
  '/gamepadLayoutScreen': typeof appGamepadLayoutScreenRoute
  '/hybrid-power': typeof appHybridPowerRoute
  '/orbitOne': typeof appOrbitOneRoute
  '/penViewer': typeof appPenViewerRoute
  '/upCycle': typeof appUpCycleRoute
  '/': typeof dashboardIndexRoute
  '/utils/automation': typeof appUtilsAutomationRoute
  '/utils/cameraCheck': typeof appUtilsCameraCheckRoute
  '/utils/deviceConfig': typeof appUtilsDeviceConfigRoute
  '/utils/eventStream': typeof appUtilsEventStreamRoute
  '/utils/inventory': typeof appUtilsInventoryRoute
  '/utils/networkHealth': typeof appUtilsNetworkHealthRoute
  '/utils/playground': typeof appUtilsPlaygroundRoute
  '/utils/settings': typeof appUtilsSettingsRoute
  '/utils/siteSetup': typeof appUtilsSiteSetupRoute
  '/layouts/$id': typeof dashboardLayoutsIdRoute
  '/layouts/new': typeof dashboardLayoutsNewRoute
  '/layouts': typeof dashboardLayoutsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/(app)': typeof appRouteRouteWithChildren
  '/(dashboard)': typeof dashboardRouteRouteWithChildren
  '/(app)/utils': typeof appUtilsRouteRouteWithChildren
  '/(dashboard)/layouts': typeof dashboardLayoutsRouteRouteWithChildren
  '/(app)/bargeControl': typeof appBargeControlRoute
  '/(app)/dev': typeof appDevRoute
  '/(app)/gamepadLayoutScreen': typeof appGamepadLayoutScreenRoute
  '/(app)/hybrid-power': typeof appHybridPowerRoute
  '/(app)/orbitOne': typeof appOrbitOneRoute
  '/(app)/penViewer': typeof appPenViewerRoute
  '/(app)/upCycle': typeof appUpCycleRoute
  '/(dashboard)/': typeof dashboardIndexRoute
  '/(app)/utils/automation': typeof appUtilsAutomationRoute
  '/(app)/utils/cameraCheck': typeof appUtilsCameraCheckRoute
  '/(app)/utils/deviceConfig': typeof appUtilsDeviceConfigRoute
  '/(app)/utils/eventStream': typeof appUtilsEventStreamRoute
  '/(app)/utils/inventory': typeof appUtilsInventoryRoute
  '/(app)/utils/networkHealth': typeof appUtilsNetworkHealthRoute
  '/(app)/utils/playground': typeof appUtilsPlaygroundRoute
  '/(app)/utils/settings': typeof appUtilsSettingsRoute
  '/(app)/utils/siteSetup': typeof appUtilsSiteSetupRoute
  '/(dashboard)/layouts/$id': typeof dashboardLayoutsIdRoute
  '/(dashboard)/layouts/new': typeof dashboardLayoutsNewRoute
  '/(dashboard)/layouts/': typeof dashboardLayoutsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/utils'
    | '/layouts'
    | '/bargeControl'
    | '/dev'
    | '/gamepadLayoutScreen'
    | '/hybrid-power'
    | '/orbitOne'
    | '/penViewer'
    | '/upCycle'
    | '/'
    | '/utils/automation'
    | '/utils/cameraCheck'
    | '/utils/deviceConfig'
    | '/utils/eventStream'
    | '/utils/inventory'
    | '/utils/networkHealth'
    | '/utils/playground'
    | '/utils/settings'
    | '/utils/siteSetup'
    | '/layouts/$id'
    | '/layouts/new'
    | '/layouts/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/utils'
    | '/bargeControl'
    | '/dev'
    | '/gamepadLayoutScreen'
    | '/hybrid-power'
    | '/orbitOne'
    | '/penViewer'
    | '/upCycle'
    | '/'
    | '/utils/automation'
    | '/utils/cameraCheck'
    | '/utils/deviceConfig'
    | '/utils/eventStream'
    | '/utils/inventory'
    | '/utils/networkHealth'
    | '/utils/playground'
    | '/utils/settings'
    | '/utils/siteSetup'
    | '/layouts/$id'
    | '/layouts/new'
    | '/layouts'
  id:
    | '__root__'
    | '/(app)'
    | '/(dashboard)'
    | '/(app)/utils'
    | '/(dashboard)/layouts'
    | '/(app)/bargeControl'
    | '/(app)/dev'
    | '/(app)/gamepadLayoutScreen'
    | '/(app)/hybrid-power'
    | '/(app)/orbitOne'
    | '/(app)/penViewer'
    | '/(app)/upCycle'
    | '/(dashboard)/'
    | '/(app)/utils/automation'
    | '/(app)/utils/cameraCheck'
    | '/(app)/utils/deviceConfig'
    | '/(app)/utils/eventStream'
    | '/(app)/utils/inventory'
    | '/(app)/utils/networkHealth'
    | '/(app)/utils/playground'
    | '/(app)/utils/settings'
    | '/(app)/utils/siteSetup'
    | '/(dashboard)/layouts/$id'
    | '/(dashboard)/layouts/new'
    | '/(dashboard)/layouts/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  appRouteRoute: typeof appRouteRouteWithChildren
  dashboardRouteRoute: typeof dashboardRouteRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/(app)': {
      id: '/(app)'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof appRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(dashboard)': {
      id: '/(dashboard)'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof dashboardRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(app)/bargeControl': {
      id: '/(app)/bargeControl'
      path: '/bargeControl'
      fullPath: '/bargeControl'
      preLoaderRoute: typeof appBargeControlRouteImport
      parentRoute: typeof appRouteRoute
    }
    '/(app)/dev': {
      id: '/(app)/dev'
      path: '/dev'
      fullPath: '/dev'
      preLoaderRoute: typeof appDevRouteImport
      parentRoute: typeof appRouteRoute
    }
    '/(app)/gamepadLayoutScreen': {
      id: '/(app)/gamepadLayoutScreen'
      path: '/gamepadLayoutScreen'
      fullPath: '/gamepadLayoutScreen'
      preLoaderRoute: typeof appGamepadLayoutScreenRouteImport
      parentRoute: typeof appRouteRoute
    }
    '/(app)/hybrid-power': {
      id: '/(app)/hybrid-power'
      path: '/hybrid-power'
      fullPath: '/hybrid-power'
      preLoaderRoute: typeof appHybridPowerRouteImport
      parentRoute: typeof appRouteRoute
    }
    '/(app)/orbitOne': {
      id: '/(app)/orbitOne'
      path: '/orbitOne'
      fullPath: '/orbitOne'
      preLoaderRoute: typeof appOrbitOneRouteImport
      parentRoute: typeof appRouteRoute
    }
    '/(app)/penViewer': {
      id: '/(app)/penViewer'
      path: '/penViewer'
      fullPath: '/penViewer'
      preLoaderRoute: typeof appPenViewerRouteImport
      parentRoute: typeof appRouteRoute
    }
    '/(app)/upCycle': {
      id: '/(app)/upCycle'
      path: '/upCycle'
      fullPath: '/upCycle'
      preLoaderRoute: typeof appUpCycleRouteImport
      parentRoute: typeof appRouteRoute
    }
    '/(app)/utils': {
      id: '/(app)/utils'
      path: '/utils'
      fullPath: '/utils'
      preLoaderRoute: typeof appUtilsRouteRouteImport
      parentRoute: typeof appRouteRoute
    }
    '/(dashboard)/': {
      id: '/(dashboard)/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof dashboardIndexRouteImport
      parentRoute: typeof dashboardRouteRoute
    }
    '/(dashboard)/layouts': {
      id: '/(dashboard)/layouts'
      path: '/layouts'
      fullPath: '/layouts'
      preLoaderRoute: typeof dashboardLayoutsRouteRouteImport
      parentRoute: typeof dashboardRouteRoute
    }
    '/(app)/utils/automation': {
      id: '/(app)/utils/automation'
      path: '/automation'
      fullPath: '/utils/automation'
      preLoaderRoute: typeof appUtilsAutomationRouteImport
      parentRoute: typeof appUtilsRouteRoute
    }
    '/(app)/utils/cameraCheck': {
      id: '/(app)/utils/cameraCheck'
      path: '/cameraCheck'
      fullPath: '/utils/cameraCheck'
      preLoaderRoute: typeof appUtilsCameraCheckRouteImport
      parentRoute: typeof appUtilsRouteRoute
    }
    '/(app)/utils/deviceConfig': {
      id: '/(app)/utils/deviceConfig'
      path: '/deviceConfig'
      fullPath: '/utils/deviceConfig'
      preLoaderRoute: typeof appUtilsDeviceConfigRouteImport
      parentRoute: typeof appUtilsRouteRoute
    }
    '/(app)/utils/eventStream': {
      id: '/(app)/utils/eventStream'
      path: '/eventStream'
      fullPath: '/utils/eventStream'
      preLoaderRoute: typeof appUtilsEventStreamRouteImport
      parentRoute: typeof appUtilsRouteRoute
    }
    '/(app)/utils/inventory': {
      id: '/(app)/utils/inventory'
      path: '/inventory'
      fullPath: '/utils/inventory'
      preLoaderRoute: typeof appUtilsInventoryRouteImport
      parentRoute: typeof appUtilsRouteRoute
    }
    '/(app)/utils/networkHealth': {
      id: '/(app)/utils/networkHealth'
      path: '/networkHealth'
      fullPath: '/utils/networkHealth'
      preLoaderRoute: typeof appUtilsNetworkHealthRouteImport
      parentRoute: typeof appUtilsRouteRoute
    }
    '/(app)/utils/playground': {
      id: '/(app)/utils/playground'
      path: '/playground'
      fullPath: '/utils/playground'
      preLoaderRoute: typeof appUtilsPlaygroundRouteImport
      parentRoute: typeof appUtilsRouteRoute
    }
    '/(app)/utils/settings': {
      id: '/(app)/utils/settings'
      path: '/settings'
      fullPath: '/utils/settings'
      preLoaderRoute: typeof appUtilsSettingsRouteImport
      parentRoute: typeof appUtilsRouteRoute
    }
    '/(app)/utils/siteSetup': {
      id: '/(app)/utils/siteSetup'
      path: '/siteSetup'
      fullPath: '/utils/siteSetup'
      preLoaderRoute: typeof appUtilsSiteSetupRouteImport
      parentRoute: typeof appUtilsRouteRoute
    }
    '/(dashboard)/layouts/': {
      id: '/(dashboard)/layouts/'
      path: '/'
      fullPath: '/layouts/'
      preLoaderRoute: typeof dashboardLayoutsIndexRouteImport
      parentRoute: typeof dashboardLayoutsRouteRoute
    }
    '/(dashboard)/layouts/$id': {
      id: '/(dashboard)/layouts/$id'
      path: '/$id'
      fullPath: '/layouts/$id'
      preLoaderRoute: typeof dashboardLayoutsIdRouteImport
      parentRoute: typeof dashboardLayoutsRouteRoute
    }
    '/(dashboard)/layouts/new': {
      id: '/(dashboard)/layouts/new'
      path: '/new'
      fullPath: '/layouts/new'
      preLoaderRoute: typeof dashboardLayoutsNewRouteImport
      parentRoute: typeof dashboardLayoutsRouteRoute
    }
  }
}

interface appUtilsRouteRouteChildren {
  appUtilsAutomationRoute: typeof appUtilsAutomationRoute
  appUtilsCameraCheckRoute: typeof appUtilsCameraCheckRoute
  appUtilsDeviceConfigRoute: typeof appUtilsDeviceConfigRoute
  appUtilsEventStreamRoute: typeof appUtilsEventStreamRoute
  appUtilsInventoryRoute: typeof appUtilsInventoryRoute
  appUtilsNetworkHealthRoute: typeof appUtilsNetworkHealthRoute
  appUtilsPlaygroundRoute: typeof appUtilsPlaygroundRoute
  appUtilsSettingsRoute: typeof appUtilsSettingsRoute
  appUtilsSiteSetupRoute: typeof appUtilsSiteSetupRoute
}

const appUtilsRouteRouteChildren: appUtilsRouteRouteChildren = {
  appUtilsAutomationRoute: appUtilsAutomationRoute,
  appUtilsCameraCheckRoute: appUtilsCameraCheckRoute,
  appUtilsDeviceConfigRoute: appUtilsDeviceConfigRoute,
  appUtilsEventStreamRoute: appUtilsEventStreamRoute,
  appUtilsInventoryRoute: appUtilsInventoryRoute,
  appUtilsNetworkHealthRoute: appUtilsNetworkHealthRoute,
  appUtilsPlaygroundRoute: appUtilsPlaygroundRoute,
  appUtilsSettingsRoute: appUtilsSettingsRoute,
  appUtilsSiteSetupRoute: appUtilsSiteSetupRoute,
}

const appUtilsRouteRouteWithChildren = appUtilsRouteRoute._addFileChildren(
  appUtilsRouteRouteChildren,
)

interface appRouteRouteChildren {
  appUtilsRouteRoute: typeof appUtilsRouteRouteWithChildren
  appBargeControlRoute: typeof appBargeControlRoute
  appDevRoute: typeof appDevRoute
  appGamepadLayoutScreenRoute: typeof appGamepadLayoutScreenRoute
  appHybridPowerRoute: typeof appHybridPowerRoute
  appOrbitOneRoute: typeof appOrbitOneRoute
  appPenViewerRoute: typeof appPenViewerRoute
  appUpCycleRoute: typeof appUpCycleRoute
}

const appRouteRouteChildren: appRouteRouteChildren = {
  appUtilsRouteRoute: appUtilsRouteRouteWithChildren,
  appBargeControlRoute: appBargeControlRoute,
  appDevRoute: appDevRoute,
  appGamepadLayoutScreenRoute: appGamepadLayoutScreenRoute,
  appHybridPowerRoute: appHybridPowerRoute,
  appOrbitOneRoute: appOrbitOneRoute,
  appPenViewerRoute: appPenViewerRoute,
  appUpCycleRoute: appUpCycleRoute,
}

const appRouteRouteWithChildren = appRouteRoute._addFileChildren(
  appRouteRouteChildren,
)

interface dashboardLayoutsRouteRouteChildren {
  dashboardLayoutsIdRoute: typeof dashboardLayoutsIdRoute
  dashboardLayoutsNewRoute: typeof dashboardLayoutsNewRoute
  dashboardLayoutsIndexRoute: typeof dashboardLayoutsIndexRoute
}

const dashboardLayoutsRouteRouteChildren: dashboardLayoutsRouteRouteChildren = {
  dashboardLayoutsIdRoute: dashboardLayoutsIdRoute,
  dashboardLayoutsNewRoute: dashboardLayoutsNewRoute,
  dashboardLayoutsIndexRoute: dashboardLayoutsIndexRoute,
}

const dashboardLayoutsRouteRouteWithChildren =
  dashboardLayoutsRouteRoute._addFileChildren(
    dashboardLayoutsRouteRouteChildren,
  )

interface dashboardRouteRouteChildren {
  dashboardLayoutsRouteRoute: typeof dashboardLayoutsRouteRouteWithChildren
  dashboardIndexRoute: typeof dashboardIndexRoute
}

const dashboardRouteRouteChildren: dashboardRouteRouteChildren = {
  dashboardLayoutsRouteRoute: dashboardLayoutsRouteRouteWithChildren,
  dashboardIndexRoute: dashboardIndexRoute,
}

const dashboardRouteRouteWithChildren = dashboardRouteRoute._addFileChildren(
  dashboardRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  appRouteRoute: appRouteRouteWithChildren,
  dashboardRouteRoute: dashboardRouteRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
